import React from 'react';
import * as _ from 'lodash';
import { getProxyUrl } from '../../utils/image';

function MatchUpStandingsRow({ item, mark, teamLogos }) {
  if (item.type === 'clip') {
    return (
      <div className="stats-table__row">
        <div className="stats-table__position stats-table__position--status">
          <svg
            className="arrow arrow--up invisible"
            width="11"
            height="13"
            viewBox="0 0 11 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div className="stats-table__name">
          <div className="name-with-team-logo">-</div>
        </div>
        <div className="stats-table__games" />
        <div className="stats-table__wins" />
        <div className="stats-table__ties" />
        <div className="stats-table__losses" />
        <div className="stats-table__plus-minus" />
        <div className="stats-table__points" />
      </div>
    );
  }

  const { name, position } = item;
  const logo = _.get(teamLogos, item?.teamAbbrv, '');
  const logoUrl = _.get(logo, 'logoImageUrl', '');

  const gamesPlayed = item?.stats?.find((stat) => stat.name === 'gp')?.value;
  const wins = item?.stats?.find((stat) => stat.name === 'w')?.value;
  const ties = item?.stats?.find((stat) => stat.name === 't')?.value;
  const losses = item?.stats?.find((stat) => stat.name === 'l')?.value;
  const points = item?.stats?.find((stat) => stat.name === 'pts')?.value;
  const gf = item?.stats?.find((stat) => stat.name === 'gf')?.value;
  const ga = item?.stats?.find((stat) => stat.name === 'ga')?.value;
  const plusMinus = `${gf}-${ga}`;

  return (
    <div
      className={mark ? 'stats-table__row bg-comp-pink' : 'stats-table__row'}
    >
      <div className="stats-table__position stats-table__position--status">
        <svg
          className="arrow arrow--up invisible"
          width="11"
          height="13"
          viewBox="0 0 11 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
            fill="currentColor"
          />
        </svg>
        {position}
      </div>
      <div className="stats-table__name">
        <div className="name-with-team-logo">
          <img className="ms-2" src={getProxyUrl(logoUrl, 30, 30)} alt="" />
          {name}
        </div>
      </div>
      <div className="stats-table__games">{gamesPlayed}</div>
      <div className="stats-table__wins">{wins}</div>
      <div className="stats-table__ties">{ties}</div>
      <div className="stats-table__losses">{losses}</div>
      <div className="stats-table__plus-minus">{plusMinus}</div>
      <div className="stats-table__points">{points}</div>
    </div>
  );
}

export default MatchUpStandingsRow;
